import { useCallback, useEffect, useMemo, useRef, useState } from "react"
import { Form } from "react-router-dom"
import { Button, Input } from "reactstrap"
import WorkplaceFilterSel from "./WorkplaceFilterSel"
import { isEqual, toNumber } from 'lodash';
import WorkplaceTitle from "./WorkplaceTitle"
import { MemberRole, WorkPlaceFilterSel, WorkPlaceCatFilter, WorkPlaceTagFilter, sp_WpFindTag, WpSliceData, WpEmpFilterType } from "../../../redux/workplace/wpTypes";
import {
  setActivePostId2, loadPostTitle, getRoleUnreadCount, setFilterSelected

} from "../../../redux/workplace/wpActions";
import { changeSelectedChat } from "../../../redux/actions";
import { useRedux } from "hooks"
import { Utils } from "helpers/utils"
import { createSelector } from "reselect"
import { UserTypes } from "../../../api"
import { getRoleUnreadCountApi } from "../../../api/wpapi"
import TextBox from "components/TextBox"
import { APIClient } from "../../../api/apiCore";
import * as urls from "../../../api/urls";
import WorkPlaceFilter from "./WorkplaceFilter"
import WpTagToolBox from "components/FloatingToolbox"
import { debounce, last, set } from "lodash";
import { Const, SKeys } from "const"
import { DbUtils } from "helpers/dbUtils";

const Title = (curUserId: number) => {
  const { dispatch, useAppSelector } = useRedux();
  const storeData = createSelector(
    (state: any) => state.WpSlice,
    (wp: WpSliceData) => ({
      roleUnread: wp.roleUnread,
    })
  );
  const { roleUnread } = useAppSelector(storeData);

  const [isDropdownOpen, setIsDropdownOpen] = useState<boolean>(false);
  const totalUnread = roleUnread.unreadFlag + roleUnread.unreadFollower + roleUnread.unreadMyPost + roleUnread.unreadOwner + roleUnread.unreadTagMe + roleUnread.unreadOrganize + roleUnread.unreadPersonFollow + roleUnread.unreadObserver;



  const onNewWpPost = () => {
    dispatch(setActivePostId2("", "ตั้งโพสใหม่", "➕", "#000000", "#C0C0C0", "New post"));
    dispatch(changeSelectedChat(null));
  }
  return (
    <div className="d-flex align-items-start">
      <div className="flex-grow-1">

        <h4>
          {/* <img src="/icons/2s-social.png" width="38"></img> */}
          2S Workplace
          {totalUnread > 0 && (<span className="unread-badge-wp p-2 ms-2">{totalUnread}</span>)}  {/* 20250519 Change total unread count to display here */}

          {/* [{curUserId}] */}
        </h4>
      </div>
      <div className="flex-shrink-0">
        <div id="add-chat-room" title="สร้างหัวข้อใหม่">
          <button type="button" className="btn btn-soft-primary btn-sm" onClick={onNewWpPost}><i className="fas fa-plus"></i></button>
        </div>
      </div>
    </div>
  )
}

interface FilterControlProps {
  keyword: string,
  onKeywordChange: (keyword: string) => void;
  onSearchTitle: (searchNow: boolean) => void;
}
const FilterControl = ({ keyword, onKeywordChange, onSearchTitle }: FilterControlProps) => {
  const onClearKeyword = async () => {
    const txt: any = document.getElementById("serachChatUser");
    if (txt) txt.value = '';
    // debouncePerformSearchContact();
  }
  const onFilterButtonClick = () => {
    // setIsFilterChatRoomModalOpen(true);
    alert('Under Construction');
  }
  const filterIcon = 'bx bx-filter-alt';
  // filterChatRoom.unRead || filterChatRoom.personUnRead || filterChatRoom.noActivity || filterChatRoom.keySelected.length > 0
  //   ? 'bx bxs-filter-alt' : 'bx bx-filter-alt';

  // const [filterText, setFilterText] = useState<string>("");

  const onSearchPost = async () => {
    onSearchTitle(true);
  }

  return (
    <div className="input-group mb-3">
      <TextBox placeholder="ค้นหา" icon13css="fas fa-search" icon13small={true} value={keyword} onChange={(e) => onKeywordChange(e.target.value)} onEnter13={onSearchPost} />
    </div>
  )
}

interface IndexProps { }
const Index = (props: IndexProps) => {
  const { dispatch, useAppSelector } = useRedux();
  const storeData = createSelector(
    (state: any) => state.Profile2,
    (state: any) => state.WpSlice,
    (p2, wp: WpSliceData) => ({
      curUserId: p2.userId,
      curUserType: p2.userType,
      tagFilterSelected: wp.tagFilterSelected,
      filterNotClose: wp.filterNotClose,
    })
  );
  const { curUserId, curUserType, tagFilterSelected, filterNotClose } = useAppSelector(storeData);

  const [filterSel, setFilterSel] = useState<WorkPlaceFilterSel[]>(
    [
      // { type: "product", icon: "fas fa-align-justify", text: "GI - ท่อกลม", keyCode: "p1" },
      // { type: "product", icon: "fas fa-align-justify", text: "เชือก", keyCode: "p2" },
      // { type: "product", icon: "fas fa-align-justify", text: "ตะแกรงสาน", keyCode: "p3" },
      // { type: "product", icon: "fas fa-align-justify", text: "ตาข่ายถัก", keyCode: "p4" },
      // { type: "product", icon: "fas fa-align-justify ", text: "ท่อประปา", keyCode: "p5" },
      // { type: "customer", icon: "fas fa-user-alt", text: "สยาม ค้าเหล็ก พัทลุง", keyCode: "c1" },
    ]
  );
  const [showFilterPanel, setShowFilterPanel] = useState<boolean>(window.innerWidth > 1400);
  const [keyword, setKeyword] = useState<string>("");
  const cssWorkPlaceFilter = showFilterPanel ? "workplace-filter-show" : "workplace-filter-hide";

  const [allTags, setAllTags] = useState<WorkPlaceCatFilter[]>([]);
  //const [filterUnread, setFilterUnread] = useState<boolean>(false);
  const [filterUnread, setFilterUnread] = useState<boolean>(Utils.Conf_WorkPlaceRememberFilter() && Utils.Conf_WorkPlaceFilterUnread());
  // const [filterNotClose, setFilterNotClose] = useState<boolean>(true);
  const [selTagIds, setSelTagIds] = useState<number[]>([]);


  const filterUnreadRef = useRef(filterUnread);
  const filterNotCloseRef = useRef(filterNotClose);
  const keywordRef = useRef(keyword);
  const selTagIdsRef = useRef(selTagIds);
  const tagFilterSelectedRef = useRef(tagFilterSelected);

  //const tagCatMatchAll = allTags.filter(t => t.tagMatchedAll).map(t => t.category);
  // const tagCatMatchAll = useMemo(() => {
  //   return allTags.filter(t => t.tagMatchedAll).map(t => t.category).filter(t => tagFilterSelected.some(x => x.category == t));
  // }, [allTags, tagFilterSelected]);
  const [tagCatMatchAll, setTagCatMatchAll] = useState<string[]>([]);
  useEffect(() => {
    const curValue = tagCatMatchAll;
    const newValue = allTags.filter(t => t.tagMatchedAll).map(t => t.category).filter(t => tagFilterSelected.some(x => x.category == t));
    const isSame =
      newValue.length === tagCatMatchAll.length &&
      newValue.every((v, i) => v === tagCatMatchAll[i]);
    if (!isSame) {
      setTagCatMatchAll(newValue);
    }
  }, [allTags, tagFilterSelected]);


  const tagCatMatchAllRef = useRef(tagCatMatchAll);
  useEffect(() => { filterUnreadRef.current = filterUnread; }, [filterUnread]);
  useEffect(() => { filterNotCloseRef.current = filterNotClose; }, [filterNotClose])
  useEffect(() => { keywordRef.current = keyword; }, [keyword]);
  useEffect(() => { selTagIdsRef.current = selTagIds; }, [selTagIds]);
  useEffect(() => { tagFilterSelectedRef.current = tagFilterSelected; }, [tagFilterSelected]);
  useEffect(() => { tagCatMatchAllRef.current = tagCatMatchAll; }, [tagCatMatchAll])

  // useEffect(() => { console.log('allTags:', allTags); }, [allTags]);


  //dispatch(loadPostTitle(keyword, [], memberRole, selTagIds, filterUnread));  

  const onToggleFilterPane = async () => {
    setShowFilterPanel(prev => !prev);
  }
  const onApplyFilter = async () => {
    setShowFilterPanel(false);
  }

  const onFilterDel = async (tagId: number) => {
    try {
      const updated = (tagFilterSelected ?? []).filter(t => t.tagId !== tagId);
      dispatch(setFilterSelected(updated, undefined));
      setAllTags(prev =>
        prev.map(eCat => ({
          ...eCat,
          tags: (eCat.tags ?? []).map(tag => tag.tagId === tagId ? { ...tag, selected: false } : tag)
        }))
      )
      // setFilterSel((prev) =>
      //   prev.filter((e: WorkPlaceFilterSel) => !(e.tagId === tagId))
      // )
      // console.log(type, keyCode);
      // const filter2 = filterSel.filter((e: WorkPlaceFilterSel) => e.type !== type && e.keyCode !== keyCode);
      // setFilterSel(filter2);
    } catch (e) {
      console.error(e);
      alert((e as any).message);
    }
  }


  const onToggleCollapse = (cat: string, collapseAll: boolean | null) => {
    if (cat === "" && collapseAll !== null) {
      setAllTags(prev => prev.map(e => ({ ...e, isCollapse: collapseAll })));
    } else {
      setAllTags(prev => prev.map(e => e.category === cat ? { ...e, isCollapse: !e.isCollapse } : e));
    }
  }

  const fnSetTagToUseState = (rs: any) => {
    if (!rs) return;
    rs.forEach((a: any) => {
      a.isCollapse = false;
      a.tagMatchedAll = false;
      a.empFilterType = WpEmpFilterType.Poster;
    });
    setAllTags(rs);
  }

  useEffect(() => {
    // load from local
    try {
      DbUtils.wp_load_tag_for_filter(curUserId).then(rs => fnSetTagToUseState(rs));
    } catch (e1) {
      Utils.HandleException(e1, false);
    }

    // load from api
    const api = new APIClient();
    api.fnPostForm(urls.WP_LOAD_TAG_FOR_FILTER, {})
      .then(rs => {
        // console.log('WP_LOAD_TAG_FOR_FILTER:', rs);
        DbUtils.wp_load_tag_for_filter(curUserId, rs);
        fnSetTagToUseState(rs);
      })
      .catch(e2 => Utils.HandleException(e2, false));
  }, []);

  const onSearchTitle = async (searchNow: boolean) => {
    // console.log('onSearchTitle:', { searchNow });
    // const includeFilterEmpRelated = allTags.find(e => e.category === Const.WP_CAT_EMP)?.empIncludePostRelated;
    const empFilterType = allTags.find(e => e.category === Const.WP_CAT_EMP)?.empFilterType ?? WpEmpFilterType.Poster;
    if (searchNow) {
      const selTagIds2 = (tagFilterSelected ?? []).map(t => t.tagId);
      // console.log('onSearchTitle: search now:', { tagCatMatchAll });
      const memberRole = Utils.GetMemberRoleFromStorage();
      dispatch(loadPostTitle(keyword, [], memberRole, selTagIds2/*selTagIds*/, filterUnread, filterNotClose, empFilterType/*includeFilterEmpRelated ?? false*/, tagCatMatchAll));
    } else {
      onSearchTitleDebounce(empFilterType/*includeFilterEmpRelated*/);
    }
  }

  // 20250818 if click icon unread, then reload all unread without other condition
  const onClickUnreadIcon = async () => {
    try {
      const memberRole = Utils.GetMemberRoleFromStorage();
      dispatch(loadPostTitle("", [], memberRole, null, true, false, WpEmpFilterType.Poster /*includeFilterEmpRelated ?? false*/, null));
    } catch (e) {
      Utils.HandleException(e, true);
    }
  }

  const onSearchTitleDebounce = useCallback(
    debounce((empFilterType: WpEmpFilterType/*includeFilterEmpRelated*/) => {

      const filterUnread = filterUnreadRef.current;
      const filterNotClose = filterNotCloseRef.current;
      const keyword = keywordRef.current;
      // const selTagIds = selTagIdsRef.current;
      const selTagIds2 = (tagFilterSelectedRef.current ?? []).map(t => t.tagId);
      // console.log('on search debounce:', tagCatMatchAllRef.current);

      // console.log('onSearchTitle: search debounce:', { keyword, filterUnread, selTagIds });
      const memberRole = Utils.GetMemberRoleFromStorage();
      dispatch(loadPostTitle(keyword, [], memberRole, selTagIds2/*selTagIds*/, filterUnread, filterNotClose, empFilterType/*includeFilterEmpRelated ?? false*/, tagCatMatchAllRef.current));

      // 20250702 from embedded mode
      const init_wpid = localStorage.getItem(SKeys.InitWpId);
      if (init_wpid) {
        dispatch(setActivePostId2(init_wpid, null, null, null, null, "Init post from InitWpId (emb mode)"));
        localStorage.removeItem(SKeys.InitWpId);
      }
    }, 300),
    [] // Dependencies are empty so it's only created once
  );

  useEffect(() => {
    if (curUserType == UserTypes.Employee && curUserId > 0) {
      onSearchTitle(false);
      dispatch(getRoleUnreadCount(false));
    }
  }, [curUserType, curUserId]);


  const onClickSearch = async () => {
    onSearchTitle(true);
  }

  const onClickTitle = async (postId: string, postTitle: string, postAbbr: string, postFore: string, postBack: string) => {
    dispatch(setActivePostId2(postId, postTitle, postAbbr, postFore, postBack, "Click post title"));
  }

  const [tagFilter, setTagFilter] = useState<any[]>([]);

  const onTagSelect = (cat: string, tagSelected: WorkPlaceFilterSel[]) => {
    try {
      const combined = [...filterSel, ...tagSelected];
      const uniqueMap = new Map<number, WorkPlaceFilterSel>();
      combined.forEach(t => {
        if (t.cat !== cat || tagSelected.some(n => n.tagId == t.tagId)) {
          uniqueMap.set(t.tagId, t);
        }
      });
      const updated = Array.from(uniqueMap.values());
      setFilterSel(updated);

    } catch (e) {
      Utils.HandleException(e, true);
    }
  }

  const setTagSearching = (cat: string, isSearching: boolean) => {
    setAllTags(prev => prev.map(e => e.category === cat ? { ...e, isSearching: isSearching } : e));
  }

  const onSearchTag = (cat: string, filter: string) => {
    try {
      const api = new APIClient();
      setTagSearching(cat, true);
      api.fnPostForm(urls.WP_SEARCH_TAG_FROM_FILTER_PANE, { cat: [cat], filter: filter, source: Const.SEARCH_TAG_FROM_FILTER_PANE_FILTERPAN })
        .then(rs => {
          const selTags = allTags.flatMap(cat1 => (cat1.tags ?? []).filter(tag => cat1.category === cat && tag.selected));
          const selIds = selTags.map(x => x.tagId);
          const newTags = rs.filter((r: any) => !selIds.includes(r.tagId));
          const mergeTags = [...selTags, ...newTags];
          // console.log('mergeTags:', mergeTags);
          // console.log('rs:', rs);

          // const x: WorkPlaceTagFilter[] = rs;
          // console.log('x:', x);
          setAllTags(prev => prev.map(t => t.category === cat ? { ...t, tags: mergeTags } : t));
          setTagSearching(cat, false);
        })
        .catch(e2 => {
          Utils.HandleException(e2, true);
          setTagSearching(cat, false);
        });
    } catch (e) {
      Utils.HandleException(e, true);
    }
  }

  const fnApplySelectedTagId = (catParm: string, tagId: number, tagName: string) => {
    let cat = catParm;
    if (cat === Const.WP_CAT_EMP_FROM_BROWSE) {
      cat = Const.WP_CAT_EMP;
    }
    // const found = (tagFilterSelected ?? []).findIndex(t => t.tagId === tagId) >= 0;
    const tagCat = allTags.find(t => t.category === cat);
    const isMultiSel = tagCat?.isMultiSel;// allTags.find(t => t.category === cat)?.isMultiSel;
    console.log('isMultiSel = ' + isMultiSel);
    const found = (tagFilterSelected ?? []).some(t => t.tagId === tagId);
    let update2 = (tagFilterSelected ?? []);
    if (!isMultiSel) {
      update2 = update2.filter(t => t.category !== cat);
    } else if (found) {
      update2 = update2.filter(t => t.tagId !== tagId);
    }

    if (!found) { // add
      const tag = allTags.flatMap(cat => (cat.tags ?? []).filter(tag => tag.tagId === tagId)
        .map(x => ({
          ...x,
          category: cat.category,
          faColor: cat.faColor,
          bgColor: cat.bgColor,
          faIcon: cat.faIcon
        })));

      if (tag.length > 0) {
        update2 = [...update2, ...tag];
      } else if (catParm === Const.WP_CAT_EMP_FROM_BROWSE) {
        console.log('xyz');
        const tag2: WorkPlaceTagFilter[] = [{
          category: cat,
          tagId: tagId,
          name: tagName,
          selected: null,
          faColor: tagCat?.faColor ?? null,
          bgColor: tagCat?.bgColor ?? null,
          faIcon: tagCat?.faIcon ?? null,
        }];
        update2 = [...update2, ...tag2];
      }
    }
    dispatch(setFilterSelected(update2, undefined));
  }

  const onClickTag = (catParm: string, tagId: number, tagName: string) => {
    try {
      let cat = catParm;
      if (cat === Const.WP_CAT_EMP_FROM_BROWSE) {
        cat = Const.WP_CAT_EMP;
        // const found = allTags.flatMap(cat1 => (cat1.tags ?? [])).some(tag => tag.category === cat && tag.tagId === tagId);
        // if (!found) {
        //   setAllTags(prev => prev.map(ee => ee.category !== cat ? ee : (
        //     {
        //       ...ee,
        //       tags: [...ee.tags, { tagId: 12, category: cat, name: "aaaa" }]
        //     })));
        // }
      }
      fnApplySelectedTagId(catParm, tagId, tagName);
      setAllTags(prev =>
        prev.map(t =>
          t.category === cat
            ? {
              ...t,
              tags: (t.tags ?? []).map(t2 =>
                t2.tagId === tagId
                  ? {
                    ...t2,
                    selected: !t2.selected
                  }
                  : {
                    ...t2,
                    selected: t.isMultiSel ? t2.selected : false
                  }
              )
            }
            : t
        )
      );
    } catch (e) {
      Utils.HandleException(e, true);
    }
  }

  const onClickMuliSel = (cat: string) => {
    try {
      const isMultiSelNew = !allTags.find(t => t.category === cat)?.isMultiSel;
      if (isMultiSelNew == false) {
        const update2 = (tagFilterSelected ?? []).filter(t => t.category !== cat);
        dispatch(setFilterSelected(update2, undefined));
      }
      setAllTags(prev =>
        prev.map(eCat =>
          eCat.category === cat
            ? {
              ...eCat,
              isMultiSel: !eCat.isMultiSel,
              tags: !eCat.isMultiSel
                ? eCat.tags
                : (eCat.tags ?? []).map(tp => ({ ...tp, selected: false }))
            }
            : eCat)
      );
    } catch (e) {
      Utils.HandleException(e, true);
    }
  }


  const onClickMatchedAll = (cat: string, matchedAll: boolean) => {
    try {
      setAllTags(prev => prev.map(t => t.category === cat ? { ...t, tagMatchedAll: matchedAll } : t))
    } catch (e) {
      Utils.HandleException(e, true);
    }
  }

  const [toggleSearch, setToggleSearch] = useState<boolean>(false);
  const fnToggleSearch = () => {
    setToggleSearch(prev => !prev);
  }

  // useEffect(() => { console.log('allTags:', allTags) }, [allTags]);
  const onClickOption = (cat: string, type: string, value: any) => {
    console.log('onClickOption:', { cat, type, value });
    try {
      setAllTags(prev => prev.map(eCat =>
        eCat.category !== cat ? eCat : {
          ...eCat
          //, empIncludePostRelated: type === "chkEmpIncludePostRelated" ? value : eCat.empIncludePostRelated
          , empFilterType: type === "WpEmpFilterType" ? toNumber(value) : eCat.empFilterType
        }
      ));
      fnToggleSearch();

    } catch (e) {
      Utils.HandleException(e, true);
    }
  }



  /* 20250612 Not use because when searching no result, the selected tag is clear, use selected when click instead
  useEffect(() => {
    const sel = allTags.flatMap(cat => (cat.tags ?? []).filter(tag => tag.selected)).map(m2 => m2.tagId);
    const sel2 = allTags.flatMap(cat => (cat.tags ?? []).filter(tag => tag.selected)
      .map(nw => ({
        ...nw,
        faColor: cat.faColor,
        bgColor: cat.bgColor,
        faIcon: cat.faIcon,
      })));
  
    dispatch(setFilterSelected(sel2));
  
    setSelTagIds(prevSel => {
      if (!isEqual(prevSel, sel)) {
        return sel;
      }
      return prevSel;
    });
  }, [allTags, dispatch]);
  */

  useEffect(() => {
    //console.log('search title when [tagFilterSelected, filterUnread, filterNotClose]:', { tagFilterSelected, filterUnread, filterNotClose });
    onSearchTitle(false);
  }, [tagFilterSelected, /*selTagIds,*/ filterUnread, filterNotClose, tagCatMatchAll, toggleSearch]);


  // useEffect(() => {
  //   console.log('selTagIds:', selTagIds);
  // }, [selTagIds]);

  // useEffect(() => {
  //   console.log('filterUnread:', filterUnread);
  // }, [filterUnread]);

  // useEffect(() => {
  //   console.log('filterNotClose:', filterNotClose);
  // }, [filterNotClose]);

  useEffect(() => {
    const onMouseDown = (event: MouseEvent) => {
      try {
        if (divRefFilter.current) {
          const computedStyle = window.getComputedStyle(divRefFilter.current);
          const isAbsolute = computedStyle.position === "absolute";
          if (isAbsolute && divRefFilter.current.classList.contains("workplace-filter-show")) {
            const isClickOutside = !divRefFilter.current.contains(event.target as Node);
            onToggleFilterPane();
            // if (isClickOutside){
            //   divRefFilter.current.classList.remove("workplace-filter-show");
            //   divRefFilter.current.classList.add("workplace-filter-hide");
            // }
          }
        }
      } catch (e) {
        Utils.HandleException(e, true);
      }
    }

    // document.addEventListener('mousedown', onMouseDown);
    return () => {
      // document.removeEventListener('mousedown', onMouseDown);
    }
  }, []);


  // useEffect(() => { console.log('allTAgs:', allTags); }, [allTags]);

  const onFilterUnreadChanged = (filterUnreadChecked: boolean) => {
    setFilterUnread(filterUnreadChecked);
    if (filterUnreadChecked) dispatch(setFilterSelected(undefined, false));
    Utils.Conf_WorkPlaceFilterUnread(filterUnreadChecked);
  }

  const divRefFilter = useRef<HTMLDivElement>(null);

  return (
    <div className="workplace-container">
      <div className="workplace-header" >
        <div className="px-4 pt-3">
          {Title(curUserId)}
          {/* <Title  /> */}
        </div>
        <div className="px-3 pt-2"  >
          <FilterControl keyword={keyword} onSearchTitle={onSearchTitle} onKeywordChange={(val) => setKeyword(val)} />
          <WorkplaceFilterSel allTags={allTags} onFilterDel={onFilterDel} />
        </div>
      </div>

      <div className="ps-2 pe-0 pt-1 workplace-content-wrapper">
        {!showFilterPanel && (
          <div className="workplace-filter-open-tall hand hide-md-bellow" style={{ display: "none" }} onClick={onToggleFilterPane}>
            <i className="fas fa-angle-right fz-15"></i>
          </div>
        )}
        <div ref={divRefFilter} className={"workplace-filter " + cssWorkPlaceFilter} style={{ /*borderRight: "solid 1px gray", borderTop: "solid 1px gray"*/ }}>
          <WorkPlaceFilter
            onApplyFilter={onApplyFilter} onClickTag={onClickTag} onClickMuliSel={onClickMuliSel} onClickMatchedAll={onClickMatchedAll}
            onTagSelect={onTagSelect} allTags={allTags} onSearchTag={onSearchTag}
            // filterUnRead={filterUnread} onFilterUnRead={(val) => { setFilterUnread(val); if (val) dispatch(setFilterSelected(undefined, false)); }}
            filterUnRead={filterUnread} onFilterUnRead={(val) => { onFilterUnreadChanged(val) }}
            filterNotClose={filterNotClose} onFilterNotClose={(val) => dispatch(setFilterSelected(undefined, val))}
            onClickOption={onClickOption} onToggleCollapse={onToggleCollapse}
          />
        </div>
        <div className="workplace-title" style={{ /*borderTop: "solid 1px gray" */ }}>
          <WorkplaceTitle onToggleFilterPane={onToggleFilterPane} onClickSearch={onClickSearch} onClickTitle={onClickTitle} onClickUnreadIcon={onClickUnreadIcon} />
        </div>
      </div>
    </div>
  )
}
export default Index;